import { QueryConfigTypes, createMetroApiConfig } from '@wix/premium-fed-sdk/@apis-infra';
import { CartApiTags } from './premium-cart.types';
import * as PremiumCartService from '@wix/ambassador-premium-cart-v1-cart/http';
export const PremiumCartApiConfig = createMetroApiConfig({
  getCart: PremiumCartService.getCart,
  getActiveCart: PremiumCartService.getActiveCart,
  applyCartActions: PremiumCartService.applyCartActions,
  createCheckout: PremiumCartService.createCheckout,
  removeLineItems: PremiumCartService.removeLineItems,
  ambassadorUpdateLineItems: PremiumCartService.updateLineItems,
  ambassadorAddLineItemsToActiveCart: PremiumCartService.addLineItemsToActiveCart
}, {
  methodsOptions: {
    getCart: {
      tags: [CartApiTags.cart]
    },
    getActiveCart: {
      queryConfigType: QueryConfigTypes.FIXED_DATA // TOCHECK - if its the same as staleTime infinity
    },
    applyCartActions: {
      queryConfigType: QueryConfigTypes.MUTATION_METHOD,
      tags: [CartApiTags.cart],
      isMutating: true
    },
    createCheckout: {
      queryConfigType: QueryConfigTypes.REALTIME_NO_REFETCH
    }
  }
});

// TODO: (omer) replace this with createMetroConfig from ambassador proto
// export const PremiumCartApiConfig: TApiConfig<TPremiumCartServiceMethods> = {
//   updateCart: {
//     name: 'updateCart',
//     service,
//     tags: [CartApiTags.cart],
//     isMutating: true,
//     queryConfigType: QueryConfigTypes.MUTATION_METHOD,
//     queryFn: async ({ request }) => {
//       const currentRevision = CART_MOCK.cart.revision;
//       if (!currentRevision) {
//         throw new Error(`no cart revision ${CART_MOCK.cart.id}`);
//       }
//       if (request.cart.revision !== currentRevision) {
//         throw new Error('trying to update cart with older revision');
//       }
//       // TODO - remove this MOCK!
//       CART_MOCK.cart = {
//         ...request.cart,
//         revision: currentRevision + 1,
//       };

//       return {
//         cart: CART_MOCK.cart,
//       };
//     },
//   },
// };
//# sourceMappingURL=premium-cart.api-config.js.map